module.exports = __webpack_public_path__ + "static/media/homebanner.ec8c8fb0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/homebanner.svg
// module id = 134
// module chunks = 0